import { apiSlice } from './apiSlice';

export interface Platform {
  id: number | string;
  name: string;
  domain: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface GetPlatformsParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
}

export interface GetPlatformsResponse {
  success: boolean;
  message: string;
  platforms: Platform[];
  pagination: {
    currentPage: number;
    totalPage: number;
    totalItems: number;
    limit: number;
  };
}

export const platformApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPlatforms: builder.query<GetPlatformsResponse, GetPlatformsParams | void>({
      query: (params) => {
        const queryParams: Record<string, any> = {};
        if (params) {
          if (params.page !== undefined) queryParams.page = params.page;
          if (params.limit !== undefined) queryParams.limit = params.limit;
          if (params.search) queryParams.search = params.search;
          if (params.status) queryParams.status = params.status;
        }
        return {
          url: '/platforms',
          params: queryParams,
        };
      },
      providesTags: ['Platforms'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetPlatformsQuery } = platformApi;
